import indigo from '@material-ui/core/colors/indigo';
import { createTheme } from '@material-ui/core/styles';

export const baseMuiTheme = {
  palette: {
    primary: indigo,
    secondary: {
      main: '#78c7c2',
      contrastText: '#fff',
    },
    beta: {
      main: '#ef4062',
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: '2px solid #c2d92b',
        },
      },
    },
    MuiInputBase: {
      root: {
        color: indigo[700],
      },
    },
    MuiButton: {
      contained: {
        '&$disabled': {
          color: 'rgba(0,0,0,0.38)',
        },
      },
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: '#212121',
        },
      },
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['Arial', 'sans-serif'].join(','),
  },
  themeName: 'Base',
};

export const muiTheme = createTheme(baseMuiTheme);

export default {
  name: 'Base',
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  colors: {
    black: '#333',
    lightGray: '#EEE',
    purple: '#2f3e9e',
    salade: '#bdd530',
    softGray: '#7D7E80',
    queenPink: '#ef4062',
  },
  header: {
    background: '#ccc',
    item: {
      titleColor: '#616161',
    },
    titleColor: '#333',
  },
  sidebar: {
    tabs: {
      active: {
        color: '#2f3e9e',
      },
      color: 'rgba(0, 0, 0, 0.3)',
    },
    active: {
      background: '#2f3e9e',
    },
    hover: {
      background: '#eee',
      color: '#fff',
    },
    logoBackground: '#333',
    textColor: '#000',
  },
};
